import React, { useEffect, useState } from "react";
import Header from "../../../../../Componets/Header";
import TableImage from "../../../../../Componets/Image";
import Status from "../../../../../Componets/Status";
import ActionButton from "../../../../../Componets/Buttons/action";
import Table from "../../../../../Componets/Table";
import {
  create_invoice_returns_csv,
  get_all_sales_returns,
} from "../../../../../Controllers/Sales/Returns";
import toast from "react-hot-toast";
import tables from "../../../../../Data/Tables/Importexport/Sales/Returns/tables";
import headers from "../../../../../Data/Tables/Importexport/Sales/Returns/headers";
import Loadercomponent from "../../../../../Componets/Loader";
import ValueTag from "../../../../../Componets/Valuetag";
import moment from "moment";
import { Button, Input, Spin } from "antd";
import UploadIcon from "../../../../../Assets/Svg/upload";
import { DownloadOutlined, UploadOutlined } from "@ant-design/icons";
import { download_all_invoice_returns_reports_csv } from "../../../../../Controllers/Dashboard/Dashboard";
import Modal from "antd/es/modal/Modal";
import formatDateDDMMYYYY from "../../../../../Main/formatDate";
import DateTimeBadge from "../../../../../Componets/DateTime/DateTimeBadge";
import { useLocation } from "react-router-dom";

const InvoiceReturnsImportExportTable = () => {
  const [loader, setLoader] = useState(false);
  const [header, setHeader] = useState(headers);
  const [body, setBody] = useState();
  let location = useLocation();

  const [pagination, setPagination] = useState({
    currentPage: 1,
    totalCount: 0,
    totalPages: 0,
  });

  const paginationdata = (data) => {
    let headerdata = {};

    header?.components?.map((value, index) => {
      headerdata[value.name] = value.value;
    });

    fetchData({
      ...data,
      search: headerdata?.search,
      sort: headerdata?.sort,
      product: headerdata?.product,
      purchase: headerdata?.purchase,
      supplier: headerdata?.supplier,
      date: headerdata?.date,
      status: headerdata?.status,
    });
  };

  const formdata = (data) => {
    let page = data?.search ? pagination?.currentPage : 1;

    fetchData({
      ...data,
      currentPage: page,
      totalCount: pagination?.totalCount,
      totalPages: pagination?.totalPages,
    });
  };

  const actiondata = (data) => {
    let headerdata = {};

    headers?.components?.map((value, index) => {
      headerdata[value.name] = value.value;
    });

    fetchData({
      ...data,
      search: headerdata?.search,
      sort: headerdata?.sort,
      product: headerdata?.product,
      purchase: headerdata?.purchase,
      supplier: headerdata?.supplier,
      date: headerdata?.date,
      status: headerdata?.status,
      currentPage: pagination?.currentPage,
      totalCount: pagination?.totalCount,
      totalPages: pagination?.totalPages,
    });
  };

  const fetchData = async (tabledata) => {
    try {
      setLoader(true);

      const data = {
        search: tabledata?.search,
        sort: tabledata?.sort,
        product: tabledata?.product,
        purchase: tabledata?.purchase,
        supplier: tabledata?.supplier,
        date: tabledata?.date,
        status: tabledata?.status,
        page: tabledata?.currentPage,
      };

      const invoice_returns = await get_all_sales_returns(data);

      if (invoice_returns?.status) {
        let data = [];

        invoice_returns?.data?.data?.map((value, index) => {
          data?.push({
            path:
              location?.pathname == "/app/billing/returns"
                ? `/app/billing/returns/view/${value?._id}`
                : `/app/sales/returns/view/${value?._id}`,
            Number: `#SR-${value?.number}`,
            Customer: value?.customer?.nam
              ? value?.customer?.nam
              : "Walk-in-customer",
            Date: <DateTimeBadge date={value?.date} />,
            Due: value?.due_date
              ? moment(value?.due_date).format("MMMM Do YYYY")
              : "",
            "Billed By": value?.created_by?.name,
            Total: value?.total?.toFixed(3),
            Delivery:
              value?.delivery_status === 2 ? (
                <span className="bg-green-100 text-green-600 text-sm px-2 py-1 rounded-lg">
                  Delivered
                </span>
              ) : value?.delivery_status === 1 ? (
                <span className="bg-yellow-100 text-yellow-600 text-sm px-2 py-1 rounded-lg">
                  Partial
                </span>
              ) : (
                <span className="bg-red-100 text-red-600 text-sm px-2 py-1 rounded-lg">
                  Pending
                </span>
              ),
            Payment:
              value?.payment_status === 2 ? (
                <span className="bg-green-100 text-green-600 text-sm px-2 py-1 rounded-lg">
                  Paid
                </span>
              ) : value?.payment_status === 1 ? (
                <span className="bg-yellow-100 text-yellow-600 text-sm px-2 py-1 rounded-lg">
                  Partial
                </span>
              ) : (
                <span className="bg-red-100 text-red-600 text-sm px-2 py-1 rounded-lg">
                  Unpaid
                </span>
              ),
            Status: <Status status={value?.status} />,
            Action:
              location?.pathname === "/app/billing/returns" ? null : (
                <ActionButton
                  edit={`/app/sales/returns/edit/${value?._id}`}
                  id={value?._id}
                  api="delete-sales-return"
                  actiondata={actiondata}
                  headers={header}
                />
              ),
          });
        });

        setBody(data);

        setPagination({
          currentPage: invoice_returns?.data?.currentPage,
          totalCount: invoice_returns?.data?.totalCount,
          totalPages: invoice_returns?.data?.totalPages,
        });

        setLoader(false);
      } else {
        toast?.error(invoice_returns?.message);
        setLoader(false);
      }
    } catch (errors) {
      toast?.error(errors?.message);
    }
  };

  const headerReset = () => {
    let componentData = [];
    headers?.components?.map((value, index) => {
      componentData?.push({
        ...value,
        value: null,
      });
    });
    setHeader({ ...headers, components: componentData });
  };

  useEffect(() => {
    fetchData();
    headerReset();
  }, []);

  const [open, setOpen] = useState(false);
  const [exportLoader, setExportLoader] = useState(false);

  const handleImport = async () => {
    setOpen(!open);
    setFile();
  };

  const handledownload = async () => {
    const dashboard = {
      search: "",
      sort: 1,
      unit: null,
      category: null,
      brand: null,
      type: null,
      status: 1,
    };

    setExportLoader(true);

    const blob = await download_all_invoice_returns_reports_csv(dashboard);

    if (blob) {
      const url = window.URL.createObjectURL(new Blob([blob]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "invoice_returns.csv");
      document.body.appendChild(link);
      link.click();
      link.remove();
      setExportLoader(false);
    } else {
      setExportLoader(false);
      toast?.error("Failed to export");
    }
  };

  const [file, setFile] = useState();
  const [buttonLoader, setButtonLoader] = useState(false);

  const handleFile = (e) => {
    setFile(e?.target?.files[0]);
  };

  const handleImportSave = async () => {
    if (file) {
      setButtonLoader(true);

      let data = {
        file: file,
      };

      const invoice_returns = await create_invoice_returns_csv(data);

      if (invoice_returns?.status) {
        toast?.success(invoice_returns?.message);
        setButtonLoader(false);
      } else {
        toast?.error(invoice_returns?.message + " " + invoice_returns?.error);
        setButtonLoader(false);
      }
    } else {
      toast?.error("Select file");
    }
  };

  return (
    <Header headers={header} setHeaders={setHeader} formdata={formdata}>
      <Loadercomponent loader={loader}>
        <div>
          <Modal
            closable={false}
            open={open}
            footer={false}
            onCancel={handleImport}
          >
            <div>
              <div className="pb-3 text-medium">Import</div>
              <Input type="file" onChange={handleFile} />
              <div className="pt-4 flex justify-end">
                <Button
                  className="form-cancel-button"
                  disabled={buttonLoader}
                  onClick={handleImport}
                >
                  Cancel
                </Button>
                {/* &nbsp; &nbsp; &nbsp; */}
                <Button
                  className="form-save-button ml-3"
                  onClick={handleImportSave}
                  disabled={buttonLoader}
                >
                  {buttonLoader ? (
                    <Spin tip="Loading" size="large" />
                  ) : (
                    "Import"
                  )}
                </Button>
              </div>
            </div>
          </Modal>
          <div className="flex justify-end mt-4">
            <div>
              <Button className="download-button" onClick={handleImport}>
                <UploadOutlined />
                Import
              </Button>
            </div>
            <div className="pl-2">
              <Button
                className="download-button"
                onClick={handledownload}
                disabled={exportLoader}
              >
                {exportLoader ? (
                  <Spin tip="Loading" className="w-full" />
                ) : (
                  <>
                    <DownloadOutlined />
                    &nbsp;Export
                  </>
                )}
              </Button>
            </div>
          </div>
        </div>
        <Table
          head={tables}
          body={body}
          pagination={pagination}
          paginationdata={paginationdata}
          summary={1}
        />
      </Loadercomponent>
    </Header>
  );
};

export default InvoiceReturnsImportExportTable;
